module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/camera_office-d8bf46b71ef0a635dc4a4f883c2f6bb7.webp";